(() => {
  const SIZE_WORDS = ['tamanho', 'size', 'numero', 'numeracao'];
  let sizeConfirmed = false;
  const normalize = (value = '') =>
    value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const isSizeControl = (control) => {
    const group = control.closest('fieldset, .product-form__input');
    const label = group?.querySelector('legend, .form__label')?.textContent || '';
    const identity = `${control.name || ''} ${label}`;
    return SIZE_WORDS.some((word) => normalize(identity).includes(word));
  };

  const getSizeControls = (productInfo) =>
    productInfo
      ? [...productInfo.querySelectorAll('variant-selects input[type="radio"], variant-selects select')].filter(
          isSizeControl
        )
      : [];

  const getSubmitButtons = (productInfo) =>
    [...productInfo.querySelectorAll('product-form button[type="submit"]')];

  const showMessage = (productInfo, visible) => {
    let message = productInfo.querySelector('[data-tutte-size-message]');
    const picker = productInfo.querySelector('variant-selects');
    if (!picker) return;

    if (!message) {
      message = document.createElement('p');
      message.dataset.tutteSizeMessage = '';
      message.className = 'tutte-size-message';
      message.textContent = 'Selecione seu tamanho para continuar.';
      picker.insertAdjacentElement('afterend', message);
    }
    message.hidden = !visible;
  };

  const lock = (productInfo) => {
    getSubmitButtons(productInfo).forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.dataset.tutteSizeLocked = 'true';
    });
    showMessage(productInfo, true);
  };

  const clearInitialSelection = (productInfo) => {
    const controls = getSizeControls(productInfo);
    if (!controls.length) return false;

    productInfo.classList.add('tutte-awaiting-size');
    lock(productInfo);
    return true;
  };

  const initialize = (productInfo) => {
    if (sizeConfirmed) {
      productInfo.dataset.tutteSizeConfirmed = 'true';
      showMessage(productInfo, false);
      return;
    }
    productInfo.dataset.tutteSizeConfirmed = 'false';
    clearInitialSelection(productInfo);
  };

  const confirmSize = (control) => {
    if (!control || !isSizeControl(control)) return;
    if (control.classList.contains('disabled') || control.disabled) return;
    const productInfo = control.closest('product-info');
    if (!productInfo) return;
    const needsManualChange = control.matches('input[type="radio"]') && control.checked && !sizeConfirmed;

    sizeConfirmed = true;
    productInfo.dataset.tutteSizeConfirmed = 'true';
    productInfo.classList.remove('tutte-awaiting-size');
    getSubmitButtons(productInfo).forEach((button) => delete button.dataset.tutteSizeLocked);
    showMessage(productInfo, false);

    setTimeout(() => {
      getSubmitButtons(productInfo).forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });
    }, needsManualChange ? 50 : 600);

    if (needsManualChange) {
      setTimeout(() => control.dispatchEvent(new Event('change', { bubbles: true })), 0);
    }
  };

  window.tutteConfirmSize = confirmSize;

  document.addEventListener(
    'change',
    (event) => {
      const control = event.target.closest('variant-selects input, variant-selects select');
      if (!control || !isSizeControl(control)) return;

      const productInfo = control.closest('product-info');
      if (!productInfo) return;
      sizeConfirmed = true;
      productInfo.dataset.tutteSizeConfirmed = 'true';
      productInfo.classList.remove('tutte-awaiting-size');
      getSubmitButtons(productInfo).forEach((button) => delete button.dataset.tutteSizeLocked);
      showMessage(productInfo, false);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const directControl = event.target.closest('variant-selects input, variant-selects select');
      const label = event.target.closest('variant-selects label[for]');
      const control = directControl || (label ? document.getElementById(label.htmlFor) : null);
      confirmSize(control);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const productInfo = event.target.closest('product-info');
      if (!productInfo || !getSizeControls(productInfo).length) return;
      if (sizeConfirmed) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      lock(productInfo);
      productInfo.querySelector('[data-tutte-size-message]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  const start = () => {
    document.querySelectorAll('product-info').forEach(initialize);

    const style = document.createElement('style');
    style.textContent = `
      .tutte-size-message { margin: .8rem 0; color: #9b1c1c; font-size: 1.4rem; font-weight: 600; }
      [data-tutte-size-locked="true"] { opacity: .55; cursor: not-allowed; }
      .tutte-awaiting-size variant-selects input[type="radio"]:checked + label {
        background: transparent;
        color: rgb(var(--color-foreground));
        box-shadow: 0 0 0 .1rem rgba(var(--color-foreground), .2);
      }
    `;
    document.head.appendChild(style);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
